import hyperdom from 'hyperdom'
import BasePaymentMethod from '../methods/basePaymentMethod.jsx'
import UpliftPaymentMethod from '../methods/uplift.jsx'
import formatPrice from '../../../../packages/ui-helpers/formatPrice.js'
import assetPath from '../../../../assetPath.js'
import moment from 'moment/moment.js'

export default class PayMonthly extends BasePaymentMethod {
  constructor (payment, upliftEligible) {
    super(payment)
    this.upliftEligible = upliftEligible
    const method = new UpliftPaymentMethod(payment)
    this.paymentMethods = {
      selected: method,
      eligible: [method],
    }
  }

  get isMonthly () {
    return true
  }

  eligible () {
    const passengersAge = moment().diff(this.payment.booking.booking.leadPassenger.dateOfBirth, 'years')

    if (this.payment.departure.sellingCompanyCode === 'CHCANS') {
      if (passengersAge < 19) {
        this.upliftEligible = false
      }
    }
    return this.upliftEligible
  }

  success () {
    this.paymentMethods.selected.success()
  }

  failed () {
    this.hasFailed = true
    this.paymentMethods.selected.failed()
    this.payment.paymentOptions.selected = this.payment.paymentOptions.eligible[0]
  }

  declined () {
    this.hasFailed = true
    this.paymentMethods.selected.declined()
    this.payment.paymentOptions.selected = this.payment.paymentOptions.eligible[0]
  }

  amount () {
    return this.payment.booking.booking.paymentOptions.full.amount
  }

  onadd () {
    this.payment.uplift.upliftApi.addInfoToNode(document.getElementById('upliftInfo'))
  }

  renderSelectableOption () {
    const isRejected = this.payment.upliftRejected
    const disabled = !this.payment.upliftLoadedInTime
    let radioProps = {disabled}, monthlyAmount
    const cssClasses = [
      'o-choice-item payment-options__item', {
        'has-discounts': this.payment.anyDiscounts(),
        '-selected': this.payment.paymentOption() === this,
      },
    ]
    if (isRejected) {
      cssClasses.push('disabled')
      radioProps = {disabled: 'disabled'}
      monthlyAmount = 'Unavailable'
    } else {
      monthlyAmount = formatPrice({
        currency: this.payment.departure.prices.currency,
        amount: this.payment.uplift.getMonthlyAmount(),
      })
    }
    return <label class={cssClasses}>
      {disabled ? this.renderErrorRibbon() : undefined}
      <input type='radio' class='o-choice-item__radio' name='payment-type'
        binding={[this.payment.paymentOptions, 'selected']}
        {...radioProps}
        value={this} />
      <div className={['o-choice-item__content o-choice-item__content payment-option__container', {disabled}]}>
        <div>
          <div className='payment-option__title'>
            <div className='payment-option__title__header'>Pay monthly</div>
            {isRejected
              ? <div>
                <span>Sorry, but Uplift was not able to approve your loan request. Please complete your purchase using a different payment method.</span>
              </div>
              : <div>Pay for your trip through financing with:
                <ul class='u-unstyled cards'>
                  <li class='u-inbl card-icon'>
                    <img src={assetPath(`/public/img/card-icons/uplift-usa.svg`)} alt='uplift-usa' />
                  </li>
                </ul>
              </div>}
          </div>
        </div>
        <div>
          <div class='payment-option__price'>
            <div class='payment-option__price-val'>
              <span>{monthlyAmount}</span>
              {!isRejected ? [<span>&nbsp;/&nbsp;</span>, <a id='upliftInfo' class='payment-options--info'>&nbsp;&nbsp;</a>] : undefined}
            </div>
          </div>
        </div>
      </div>
      <div className={['payment-option__methods-container', {'show-expanded': this.payment.paymentOption() === this}]}>
        <div className='payment-options'>
          {this.upliftEligible && this.payment.paymentOption() === this
            ? this.paymentMethods.selected
            : ''}
        </div>
        {this.payment.paymentOption() === this ? this.paymentMethods.selected.renderPaymentSummary() : ''}
      </div>
    </label>
  }

  render (){
    return  (!this.hasFailed) ? this.renderSelectableOption() : undefined
  }

  renderErrorRibbon () {
    return <span className='ribbon -right payment-option__ribbon--unavailable'>TEMPORARILY UNAVAILABLE</span>
  }

  renderMonthlySubtitle () {
    return <div>Pay for your trip through financing with
      <span className='card-icon uplift-usa'/>
    </div>
  }
}
